import { Box, Typography } from '@mui/material'
import React from 'react'

interface LabelProps {
    imageUrl: string
    text: string
    textColor: string
    textBackgroundColor: string
}

function parseARGBHexToRgba(hex: string): string {
    const cleanHex = hex.replace(/^0x/, '').padStart(8, '0')
    const alpha = parseInt(cleanHex.slice(0, 2), 16) / 255
    const red = parseInt(cleanHex.slice(2, 4), 16)
    const green = parseInt(cleanHex.slice(4, 6), 16)
    const blue = parseInt(cleanHex.slice(6, 8), 16)

    return `rgba(${red}, ${green}, ${blue}, ${alpha.toFixed(2)})`
}

const VodItemLabel = ({ label }: { label: LabelProps }) => {
    const containerStyle = {
        padding: '8px',
        borderRadius: '8px',
        position: 'relative',
        width: 'max-content',
    }

    return label?.imageUrl ? (
        <img src={label.imageUrl} alt={label.text} />
    ) : (
        <>
            {label && label.text && (
                <Box
                    bgcolor={
                        label.textBackgroundColor
                            ? parseARGBHexToRgba(label.textBackgroundColor)
                            : 'custom.lightGray'
                    }
                    sx={containerStyle}>
                    <Typography
                        color={
                            label.textColor
                                ? parseARGBHexToRgba(label.textColor)
                                : 'primary.main'
                        }
                        fontSize="16px"
                        fontWeight="bold">
                        {label.text.toUpperCase()}
                    </Typography>
                </Box>
            )}
        </>
    )
}

export { VodItemLabel }
